export class FileConstants {
  public static readonly FILE_EXTENSIONS = {
    PDF: '.pdf',
  };
}
